import React, { Component } from 'react';

class NavBar extends Component {
    render() {
        return (
            <div className="nav-bar">
                <h3 style={{ fontFamily: "var(--font-titles)", color: 'var(--foreground, #000)', fontWeight: 'bold' }}>Navbar</h3>
                <div className="col-md-12" style={{
                    backgroundColor: 'var(--navbar-background, #fff)',
                    border: '1px solid var(--border, #ccc)',
                    padding: '20px 30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: 'var(--radius, 10px)',
                    boxShadow: 'var(--shadow-sm)'
                }}>
                    <div
                        className="spark-icon-menu-hamburger interactive-element-hover"
                        tabIndex="0"
                        style={{
                            fontSize: '36px',
                            color: 'var(--navbar-foreground, #000)',
                            cursor: 'pointer'
                        }}>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <a href="#!" className="interactive-element-hover" style={{
                            color: 'var(--navbar-foreground, #000)',
                            marginRight: '20px',
                            textDecoration: 'none',
                            borderBottom: 'none',
                            fontFamily: "var(--font-body)"
                        }}>SIGN IN</a>
                        <span
                            className="spark-icon-shopping-cart spark-icon--md interactive-element-hover"
                            tabIndex="0"
                            style={{
                                color: 'var(--navbar-foreground, #000)',
                                cursor: 'pointer'
                            }}>
                        </span>
                        <span
                            className="spark-icon-close spark-icon--md interactive-element-hover"
                            tabIndex="0"
                            style={{
                                color: 'var(--navbar-foreground, #000)',
                                marginLeft: '26px',
                                cursor: 'pointer'
                            }}>
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/NavBar.js